export default "__VITE_ASSET__BGeZgUjp__"